import { render, staticRenderFns } from "./StarBirthday.vue?vue&type=template&id=18fb6f94&scoped=true&"
import script from "./StarBirthday.vue?vue&type=script&lang=js&"
export * from "./StarBirthday.vue?vue&type=script&lang=js&"
import style0 from "./StarBirthday.vue?vue&type=style&index=0&id=18fb6f94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb6f94",
  null
  
)

export default component.exports